import React from 'react'
import StarIcon from '@material-ui/icons/Star'
import { defaultInsertStrings } from '../constants'
import * as constants from '../constants'
import { initialSettings } from '../constants'
import { LANGUAGE_SHORT_CODE } from '../constants'
import { Word } from '../containers';
import { WID, getWord } from '../constants/Language';

export const getRootURL = () => {
  if (process.env.NODE_ENV === 'production' && window.location.port !== '3000') {
    return 'https://v1.renjuportal.com'
  }
  else {
    //return 'http://renjuportal.com:3000'
    return 'https://ab1416838257.ngrok.io'
  }
}

export const getBreakpointsEnable = (theme, width) => {
  return {
    xs: Boolean(width < theme.breakpoints.values.sm),
    sm: Boolean(width >= theme.breakpoints.values.sm),
    md: Boolean(width >= theme.breakpoints.values.md),
  }
}

export const coordinateXString = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O']
export const coordinateYString = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15']

export const renjuBoardCardToStr = (card) => {
  const { moves, settings, gameInfo, isAnalyzeMode, editMode, puzzleInfo, operationMode, analyzeStartNum } = card
  var move, strMove, strMarks, strMarksList, marks, mark, strPuzzleBlack, strPuzzleWhite, turn, item
  var v, md, op, mv, mk, an, tl, bp, wp, gr, pb, pw, tr, pt, lv, or, sw, fn, fm, sk
  strMove = ''
  strMarksList = []
  strPuzzleBlack = ''
  strPuzzleWhite = ''

  v = '2'
  switch (editMode) {
    case constants.editModeType.NORMAL:
      md = 'n'
      if (operationMode === constants.operationModeType.EDIT) {
        op = 'e'
      }
      else if (operationMode === constants.operationModeType.VIEW) {
        op = 'v'
      }
      for (move of moves){
        if (move.x < 0 || move.x > 14 || move.y < 0 || move.y > 14){
          continue
        }
        else if (move.number && move.number !== 0) {
          strMove += move.x.toString(16) + move.y.toString(16)
        }
        if (move.marks.length > 0) {
          strMarks = []
          strMarks.push(('00' + move.number.toString(16)).slice(-2))
          for (mark of move.marks){
            if (mark.x < 0 || mark.x > 14 || mark.y < 0 || mark.y > 14){
              continue
            }
            strMarks.push(mark.x.toString(16) + mark.y.toString(16) + encodeURIComponent(mark.str))
          }
          strMarksList.push(strMarks.join(''))
        }
      }
      if (strMove.length > 0) {
        mv = strMove
      }

      if (strMarksList.length > 0) {
        mk = strMarksList.join('-')
      }

      if (isAnalyzeMode === true){
        an = (analyzeStartNum + 1).toString(10)
      }
      if (
        gameInfo.openingRule !== undefined &&
        gameInfo.openingRule !== constants.OPENING_RULE.NONE
      ) {
        sw = ''
        fm = ''
        item = constants.openingRuleItems.find(it => it.value === gameInfo.openingRule)
        or = item.short
        moves.forEach(move => { 
          if (move.swap !== undefined) {
            sw += move.swap === true ? '1' : '2'
          }
          if (move.fiveMoveNumber !== undefined) {
            fn = move.fiveMoveNumber.toString(10)
          }
          if (move.fiveMoves !== undefined) {
            move.fiveMoves.forEach(move => fm += `${move.x.toString(15)}${move.y.toString(15)}`)
          }
        })
        sw = sw === '' ? undefined : sw
        fm = fm === '' ? undefined : fm
      }

      if (settings.isVisibleGameInfo === true){
        if (settings.isVisibleTitle === true && gameInfo.title && gameInfo.title !== '') {
          tl = encodeURIComponent(gameInfo.title)
        }
        if (settings.isVisiblePlayerName === true) {
          if (gameInfo.blackPlayerName && gameInfo.blackPlayerName !== '') {
            bp = encodeURIComponent(gameInfo.blackPlayerName)
          }
          if (gameInfo.whitePlayerName && gameInfo.whitePlayerName !== '') {
            wp = encodeURIComponent(gameInfo.whitePlayerName)
          }
        }
        if (
          settings.isVisibleGameResult &&
          gameInfo.gameEndNumber && gameInfo.gameEndNumber !== '' &&
          gameInfo.gameResult && gameInfo.gameResult !== ''
        ) {
          gr = gameInfo.gameEndNumber + '-' + gameInfo.gameResult
        }
      }
      if (settings.skin !== "default") {
        sk = settings.skin
      }
      break
    case constants.editModeType.PUZZLE:
      md = 'p'
      op = 's'
      for (move of moves){
        if (move.number === 0) {
          if (move.x < 0 || move.x > 14 || move.y < 0 || move.y > 14) {
            continue
          }
          if (move.color === constants.stoneType.BLACK) {
            strPuzzleBlack += move.x.toString(16) + move.y.toString(16)
          }
          else if (move.color === constants.stoneType.WHITE) {
            strPuzzleWhite += move.x.toString(16) + move.y.toString(16)
          }
          if (move.marks.length > 0) {
            marks = move.marks
          }
        }
        else {
          if (move.x < 0 || move.x > 14 || move.y < 0 || move.y > 14){
            continue
          }
          else {
            strMove += move.x.toString(16) + move.y.toString(16)
          }
          if (move.marks.length > 0) {
            strMarks = []
            strMarks.push(('00' + move.number.toString(16)).slice(-2))
            for (mark of move.marks){
              if (mark.x < 0 || mark.x > 14 || mark.y < 0 || mark.y > 14){
                continue
              }
              strMarks.push(mark.x.toString(16) + mark.y.toString(16) + encodeURIComponent(mark.str))
            }
            strMarksList.push(strMarks.join(''))
          }
        }
      }
      if (marks && marks.length > 0) {
        strMarks = []
        strMarks.push('00')
        for (mark of marks) {
          if (mark.x < 0 || mark.x > 14 || mark.y < 0 || mark.y > 14){
            continue
          }
          strMarks.push(mark.x.toString(16) + mark.y.toString(16) + encodeURIComponent(mark.str))
        }
        strMarksList.push(strMarks.join(''))
      }

      if (strPuzzleBlack.length > 0) {
        pb = strPuzzleBlack
      }

      if (strPuzzleWhite.length > 0) {
        pw = strPuzzleWhite
      }

      if (puzzleInfo) {
        if (operationMode === constants.operationModeType.EDIT) {
          if (puzzleInfo.selectedTurn === constants.turnType.AUTO) {
            turn = judgePuzzleTurn(card)
          }
          else {
            turn = puzzleInfo.selectedTurn
          }
        }
        else {
          turn = puzzleInfo.turn
        }
        if (turn === constants.turnType.BLACK) {
          tr = 'b'
        }
        else if (turn === constants.turnType.WHITE) {
          tr = 'w'
        }
        if (puzzleInfo.type !== '') {
          pt = puzzleInfo.type
        }
        if (puzzleInfo.level !== ''){
          lv = puzzleInfo.level
        }
      }

      if (strMove.length > 0) {
        mv = strMove
      }

      if (strMarksList.length > 0) {
        mk = strMarksList.join('-')
      }
      if (settings.skin !== "default") {
        sk = settings.skin
      }
      break
    default:
      break
  }
  return { v, md, op, mv, pb, pw, tr, mk, an, tl, bp, wp, gr, pt, lv, or, sw, fn, fm, sk }
}


export const renjuBoardCardToStr_old = (card) => {
  const { moves, settings, gameInfo, isAnalyzeMode, operationMode, analyzeStartNum } = card
  var move, mark, strMarks, strMarksList, op, mv, mk, an, tl, bp, wp, gr
  if (operationMode){
    op = 'e'
  }
  else {
    op = 'v'
  }
  strMarks = []
  strMarksList = []
  if (moves.length > 0){
    mv = ''
  }
  for (move of moves){
    if (move.x < 0 || move.x > 14 || move.y < 0 || move.y > 14){
      mv += 'ff'
    }
    else if (move.number !== 0) {
      mv += move.x.toString(16) + move.y.toString(16)
    }
    if (move.marks.length > 0) {
      strMarks.push(('00' + move.number.toString(16)).slice(-2))
      for (mark of move.marks){
        if (mark.x < 0 || mark.x > 14 || mark.y < 0 || mark.y > 14){
          strMarks.push('ff' + encodeURIComponent(mark.str))
        }
        strMarks.push(mark.x.toString(16) + mark.y.toString(16) + encodeURIComponent(mark.str))
      }
      strMarksList.push(strMarks.join(''))
      strMarks = []
    }
  }

  if (strMarksList.length > 0) {
    mk = strMarksList.join('-')
  }
  
  if (isAnalyzeMode === true && analyzeStartNum >= 0 && analyzeStartNum < moves.length){
    an = (analyzeStartNum + 1).toString(10)
  }

  if (settings.isVisibleGameInfo === true){
    if (settings.isVisibleTitle === true && gameInfo.title !== '') {
      tl = encodeURIComponent(gameInfo.title)
    }
    if (settings.isVisiblePlayerName === true) {
      if (gameInfo.blackPlayerName !== '') {
        bp = encodeURIComponent(gameInfo.blackPlayerName)
      }
      if (gameInfo.whitePlayerName !== '') {
        wp = encodeURIComponent(gameInfo.whitePlayerName)
      }
    }
    if (settings.isVisibleGameResult === true) {
      gr = gameInfo.gameEndNumber + '-' + gameInfo.gameResult
    }
  }

  return { op, mv, mk, an, tl, bp, wp, gr }
}

export const objectSort = (obj) => {
  if (obj === null) {
    return null
  }
  var keys = Object.keys(obj).sort()
  var map = {}
  keys.forEach(function(key){
    var val = obj[key]
    if(typeof val === "object"){
      val = objectSort(val)
    }
    map[key] = val
  })
  return map
}


export const makeGameResultStr = (gameEndNumber, gameResult) => {
  var strList, gameResultStr
  strList = gameEndNumber.split('-')
  if (strList.length !== 2) {
    return ''
  }
  gameResultStr = strList[1] + ' にて'
  if ( gameResult === 'BlackWin' ) {
    gameResultStr += '白投了'
  }
  else if ( gameResult === 'WhiteWin' ) {
    gameResultStr += '黒投了'
  }
  else if ( gameResult === 'Draw' ) {
    gameResultStr += '満局'
  }
  return gameResultStr
}

export const judgePuzzleTurn = (card) => {
  var totalBlack, totalWhite, turn
  if (card.puzzleInfo.selectedTurn === constants.turnType.AUTO) {
    totalBlack = card.moves.filter((move) => move.number === 0 && move.color === constants.stoneType.BLACK).length
    totalWhite = card.moves.filter((move) => move.number === 0 && move.color === constants.stoneType.WHITE).length
    if (totalBlack <= totalWhite) {
      turn = constants.turnType.BLACK
    }
    else {
      turn = constants.turnType.WHITE
    }
  }
  return turn
}


export const createURLParamV2 = (card, targets) => {
  var boardContext, params
  params = []
  boardContext = renjuBoardCardToStr(card)
  Object.keys(boardContext).forEach((key) => {
    if (boardContext[key] !== undefined) {
      if (targets !== undefined) {
        if (targets.some((target) => target === key)) {
          params.push(`${key}=${boardContext[key]}`)  
        }
      }
      else {
        params.push(`${key}=${boardContext[key]}`)
      }
    }
  })
  return params.join('&')
}

export const createURLParam = (card) => {
  const { moves, settings, gameInfo, isAnalyzeMode, operationMode, analyzeStartNum } = card
  var move, param, strMove, strMarks, strMarksList, mark
  param = []
  param.push('v=1')
  switch (operationMode) {
    case constants.operationModeType.EDIT:
      param.push('md=e')
      break
    case constants.operationModeType.VIEW:
      param.push('md=v')
      break
    default:
      break
  }
  strMove = 'rc='
  strMarks = []
  strMarksList = []
  for (move of moves){
    if (move.x < 0 || move.x > 14 || move.y < 0 || move.y > 14){
      strMove += 'ff'
    }
    else if (move.number && move.number !== 0) {
      strMove += move.x.toString(16) + move.y.toString(16)
    }
    if (move.marks.length > 0) {
      strMarks.push(('00' + move.number.toString(16)).slice(-2))
      for (mark of move.marks){
        if (mark.x < 0 || mark.x > 14 || mark.y < 0 || mark.y > 14){
          strMarks.push('ff' + encodeURIComponent(mark.str))
        }
        strMarks.push(mark.x.toString(16) + mark.y.toString(16) + encodeURIComponent(mark.str))
      }
      strMarksList.push(strMarks.join(''))
      strMarks = []
    }
  }
  param.push(strMove)

  if (strMarksList.length > 0) {
    param.push('mc=' + strMarksList.join('-'))
  }
  
  if (isAnalyzeMode === true){
    param.push('an=' + (analyzeStartNum + 1).toString(10))
  }

  if (settings.isVisibleGameInfo === true){
    if (settings.isVisibleTitle === true && gameInfo.title !== '') {
      param.push('tl=' + encodeURIComponent(gameInfo.title))
    }
    if (settings.isVisiblePlayerName === true) {
      if (gameInfo.blackPlayerName !== '') {
        param.push('bp=' + encodeURIComponent(gameInfo.blackPlayerName))
      }
      if (gameInfo.whitePlayerName !== '') {
        param.push('wp=' + encodeURIComponent(gameInfo.whitePlayerName))
      }
    }
    if (settings.isVisibleGameResult === true) {
      param.push('gr=' + gameInfo.gameEndNumber + '-' + gameInfo.gameResult )
    }
  }

  return param.join('&')
}

export const strToRenjuBoardCard = (str) => {
  var newStr
  switch (str.v) {
    case 1:
      newStr = convertStrV1ToV2(str)
      return strToRenjuBoardCardV2(newStr)
    case 2:
      return strToRenjuBoardCardV2(str)
    default:
      return strToRenjuBoardCardV2(str)
  }
}

const convertStrV1ToV2 = (str) => {
  return {
    md: 'n',
    op: str.md,
    mv: str.rc,
    mk: str.mc,
    an: str.an,
    tl: str.tl,
    bp: str.bp,
    wp: str.wp,
    gr: str.gr,
    or: str.or,
    sw: str.sw,
    fn: str.fn,
    fm: str.fm,
  }
}

export const strToRenjuBoardCardV2 = (str) => {
  const { md, op, pb, pw, tr, mv, mk, an, tl, bp, wp, gr, pt, lv, or, sw, fn, fm, sk } = str
  var posStr, move, color, x, y, markParam, strMarks, number, markList, mark, titleParam, blackPlayerNameParam, whitePlayerNameParam, gameResult, item, initialMove, strFiveMoves, fiveMoves
  var card = {
    moves: [{ x: null, y: null, color: null, number: 0, marks: [], insertStrings: defaultInsertStrings}],
    movesAnalyze: [{ x: null, y: null, color: null, number: 0, marks: [], insertStrings: defaultInsertStrings}],
    movesHistory: [{ x: null, y: null, color: null, number: 0, marks: [], insertStrings: defaultInsertStrings}] ,
    editMode: constants.editModeType.NORMAL,
    operationMode: constants.operationModeType.EDIT,
    puzzleInfo: {},
    settings: deepCopy(initialSettings),
    gameInfo: {},
  }
  if (md) {
    switch (md) {
      case 'n':
        card.editMode = constants.editModeType.NORMAL
        break
      case 'p':
        card.editMode = constants.editModeType.PUZZLE
        card.operationMode = constants.operationModeType.SET
        card.puzzleInfo = {
          turn: constants.turnType.BLACK,
          selectedTurn: constants.turnType.BLACK,
        }
        break
      default: break
    }
  }

  if (op) {
    if (card.editMode === constants.editModeType.NORMAL) {
      switch (op) {
        case 'e': card.operationMode = constants.operationModeType.EDIT; break
        case 'v': card.operationMode = constants.operationModeType.VIEW; break
        default: card.operationMode = constants.operationModeType.EDIT; break
      }
    }
  }

  if (pb) {
    posStr = pb.match(/.{2}/g)
    if (null !== posStr) {
      Array.prototype.push.apply(card.moves, posStr.map((str) => {
        color = constants.stoneType.BLACK
        x = isNaN(parseInt(str[0], 15)) ? null : parseInt(str[0], 15)
        y = isNaN(parseInt(str[1], 15)) ? null : parseInt(str[1], 15)
        return { x, y, color, number: 0, marks: [], insertStrings: defaultInsertStrings }
      }))
    }
    card.movesHistory = deepCopy(card.moves)
  }

  if (pw) {
    posStr = pw.match(/.{2}/g)
    if (null !== posStr) {
      Array.prototype.push.apply(card.moves, posStr.map((str) => {
        color = constants.stoneType.WHITE
        x = isNaN(parseInt(str[0], 15)) ? null : parseInt(str[0], 15)
        y = isNaN(parseInt(str[1], 15)) ? null : parseInt(str[1], 15)
        return { x, y, color, number: 0, marks: [], insertStrings: defaultInsertStrings }
      }))
    }
    card.movesHistory = deepCopy(card.moves)
  }

  if (tr) {
    switch (tr) {
      case 'b':
        card.puzzleInfo.turn = constants.turnType.BLACK
        card.puzzleInfo.selectedTurn = constants.turnType.BLACK
        break
      case 'w':
        card.puzzleInfo.turn = constants.turnType.WHITE
        card.puzzleInfo.selectedTurn = constants.turnType.WHITE
        break
      default:
        card.puzzleInfo.selectedTurn = constants.turnType.AUTO
        break
    }
  }
  else if (card.editMode === constants.editModeType.PUZZLE) {
    card.puzzleInfo.selectedTurn = constants.turnType.AUTO
    card.puzzleInfo.turn = judgePuzzleTurn(card)
  }
  
  if (pt) {
    if (constants.puzzleTypeItems.some((item) => item.value === pt)) {
      card.puzzleInfo.type = pt
    }
  }

  if (lv) {
    if (constants.puzzleLevelItems.some((item) => item.value === lv.toString(10))) {
      card.puzzleInfo.level = lv.toString(10)
    }
  }

  if (or) {
    item = constants.openingRuleItems.find(it => it.short === or)
    if (item !== undefined) {
      card.gameInfo.openingRule = item.value
      switch (card.gameInfo.openingRule) {
        case constants.OPENING_RULE.SOOSYRV8:
          card.gameInfo.soosyrv8 = { swap1: undefined, swap2: undefined, fiveMoveNumber: 1, fiveMoves: [] }
          break
        default:
          break
      }
    }
  }

  if (mv) {
    posStr = mv.match(/.{2}/g)
    if (null !== posStr){
      Array.prototype.push.apply(card.moves, posStr.map((str, index) => {
        number = index + 1
        if (tr) {
          if (card.puzzleInfo.turn === constants.turnType.BLACK) {
            color = 0 === number % 2 ? 'white' : 'black'
          }
          else if (card.puzzleInfo.turn === constants.turnType.WHITE) {
            color = 0 === number % 2 ? 'black' : 'white'
          }
        }
        else {
          color = 0 === number % 2 ? "white" : "black"
        }
        x = isNaN(parseInt(str[0], 15)) ? null : parseInt(str[0], 15)
        y = isNaN(parseInt(str[1], 15)) ? null : parseInt(str[1], 15)
        return { x, y, color, number, marks: [], insertStrings: defaultInsertStrings }
      }))
    }
    initialMove = { x: null, y: null, color: null, number: 0, marks: [], insertStrings: defaultInsertStrings }
    switch (card.gameInfo.openingRule) {
      case constants.OPENING_RULE.SOOSYRV8:
        if (card.moves.length >= 4) {
          if (sw && null !== sw.match(/^1|^2/)) {
            card.moves.splice(4, 0, { ...deepCopy(initialMove), swap: Boolean(sw[0] === '1') })
            card.gameInfo.soosyrv8.swap1 = Boolean(sw[0] === '1')
          }
          else {
            card.moves.splice(4, card.moves.length - 4)
            break
          }
        }
        else {
          break
        }
        if (card.moves.length >= 6) {
          if (fn && fn >= 1 && fn <= 8){
            card.moves.splice(6, 0, { ...deepCopy(initialMove), fiveMoveNumber: fn })
            card.gameInfo.soosyrv8.fiveMoveNumber = fn
          }
          else {
            card.moves.splice(6, card.moves.length - 6)
            break
          }
        }
        else {
          break
        }
        if (card.moves.length >= 7) {
          if (sw && null !== sw.match(/.+1|.+2/)) {
            card.moves.splice(7, 0, { ...deepCopy(initialMove), swap: Boolean(sw[1] === '1') })
            card.gameInfo.soosyrv8.swap2 = Boolean(sw[1] === '1')
          }
          else {
            card.moves.splice(7, card.moves.length - 7)
            break
          }
        }
        else {
          break
        }
        if (card.moves.length >= 8) {
          if (fm && fm.length === fn * 2) {
            strFiveMoves = fm.match(/.{2}/g)
            if (null !== strFiveMoves) {
              fiveMoves = strFiveMoves.map(str => {
                x = isNaN(parseInt(str[0], 15)) ? null : parseInt(str[0], 15)
                y = isNaN(parseInt(str[1], 15)) ? null : parseInt(str[1], 15)
                return { x, y }
              })
              card.moves.splice(8, 0, { ...deepCopy(initialMove), fiveMoves: deepCopy(fiveMoves) })
              card.gameInfo.soosyrv8.fiveMoves = deepCopy(fiveMoves)
            }
            else {
              card.moves.splice(8, card.moves.length - 8)
              break
            }
          }
          else {
            card.moves.splice(8, card.moves.length - 8)
            break
          }
        }
        else {
          break
        }
        break
      default:
        break
    }
    if (an && card.moves.length >= parseInt(an, 10)) {
      card.analyzeStartNum = parseInt(an, 10) - 1
      card.movesAnalyze = card.moves.slice(0, card.moves.length)
      card.movesHistory = card.moves.slice(0, card.analyzeStartNum)
      card.isAnalyzeMode = true
    }
    else {
      card.movesAnalyze = card.moves.slice(0, 1)
      card.movesHistory = card.moves.slice(0, card.moves.length)
    }
  }


  if (mk) {
    markParam = decodeURIComponent(mk)
    for (strMarks of markParam.split('-')) {
      number = parseInt(strMarks.slice(0,2), 16)
      markList = strMarks.slice(2, strMarks.length).match(/.{3}/g)
      for (mark of markList) {
        x = isNaN(parseInt(mark[0], 15)) ? null : parseInt(mark[0], 15)
        y = isNaN(parseInt(mark[1], 15)) ? null : parseInt(mark[1], 15)
        for (move of card.moves) {
          if (move.number !== number) {
            continue
          }
          move.marks.push({x, y, str: mark[2]})
        }
      }
    }
  }
  if (tl | bp | wp | gr) {
    card.settings.isVisibleGameInfo = true
  }
  if (tl) {
    titleParam = decodeURIComponent(tl)
    card.gameInfo.title = titleParam
    card.settings.isVisibleTitle = true
  }
  if (bp) {
    blackPlayerNameParam = decodeURIComponent(bp)
    card.gameInfo.blackPlayerName = blackPlayerNameParam
    card.settings.isVisiblePlayerName = true
  }
  if (wp) {
    whitePlayerNameParam = decodeURIComponent(wp)
    card.gameInfo.whitePlayerName = whitePlayerNameParam
    card.settings.isVisiblePlayerName = true
  }
  if (gr) {
    gameResult = gr.split('-')
    if (gameResult.length === 3){
      card.gameInfo.gameEndNumber = gameResult[0] + '-' + gameResult[1]
      card.gameInfo.gameResult = gameResult[2]
      card.settings.isVisibleGameResult = true
    }
  }
  if (sk) {
    card.settings.skin = sk
  }

  return card
}


export const strToRenjuBoardCardV1 = (str) => {
  const { md, mv, mk, an, tl, bp, wp, gr } = str
  var posStr, move, color, x, y, markParam, strMarks, number, markList, mark, titleParam, blackPlayerNameParam, whitePlayerNameParam, gameResult
  var card = {}
  if (md){
    switch(md) {
      case 'e':
        card.operationMode = constants.operationModeType.EDIT
        break
      case 'v':
        card.operationMode = constants.operationModeType.VIEW
        break
      default:
        break
    }
  }

  card.moves = []
  card.moves.push({ x: null, y: null, color: null, number: 0, marks: [], insertStrings: defaultInsertStrings})
  if (mv) {
    posStr = mv.match(/.{2}/g)
    if (null !== posStr){
      for (let index = 0; index < posStr.length; index++) {
        color = 0 === card.moves.length % 2 ? "white" : "black"
        x = isNaN(parseInt(posStr[index][0], 15)) ? null : parseInt(posStr[index][0], 15)
        y = isNaN(parseInt(posStr[index][1], 15)) ? null : parseInt(posStr[index][1], 15)
        card.moves = card.moves.concat({x: x, y: y, color: color, number: index + 1, marks: [], insertStrings: defaultInsertStrings})
      }
    }
    if (an && card.moves.length >= parseInt(an, 10)) {
      card.analyzeStartNum = parseInt(an, 10)
      card.movesAnalyze = card.moves.slice(0, card.moves.length)
      card.movesHistory = card.moves.slice(0, card.analyzeStartNum)
      card.isAnalyzeMode = true
    }
    else {
      card.movesAnalyze = card.moves.slice(0, 1)
      card.movesHistory = card.moves.slice(0, card.moves.length)
    }
  }
  else {
    card.movesAnalyze = deepCopy(card.moves)
    card.movesHistory = deepCopy(card.moves)
  }

  if (mk) {
    markParam = decodeURIComponent(mk)
    for (strMarks of markParam.split('-')) {
      number = parseInt(strMarks.slice(0,2), 16)
      markList = strMarks.slice(2, strMarks.length).match(/.{3}/g)
      for (mark of markList) {
        x = isNaN(parseInt(mark[0], 16)) ? null : parseInt(mark[0], 16)
        y = isNaN(parseInt(mark[1], 16)) ? null : parseInt(mark[1], 16)
        for (move of card.moves) {
          if (move.number !== number) {
            continue
          }
          move.marks.push({x, y, str: mark[2]})
        }
      }
    }
  }
  if (tl || bp || wp || gr) {
    card.settings = {}
    card.gameInfo = {}
  }
  if (tl) {
    titleParam = decodeURIComponent(tl)
    card.gameInfo.title = titleParam
    card.settings.isVisibleTitle = true
  }
  if (bp) {
    blackPlayerNameParam = decodeURIComponent(bp)
    card.gameInfo.blackPlayerName = blackPlayerNameParam
    card.settings.isVisiblePlayerName = true
  }
  if (wp) {
    whitePlayerNameParam = decodeURIComponent(wp)
    card.gameInfo.whitePlayerName = whitePlayerNameParam
    card.settings.isVisiblePlayerName = true
  }
  if (gr) {
    gameResult = gr.split('-')
    if (gameResult.length === 3){
      card.gameInfo.gameEndNumber = gameResult[0] + '-' + gameResult[1]
      card.gameInfo.gameResult = gameResult[2]
      card.settings.isVisibleGameResult = true
    }
  }

  return card
}

export const getLevelIcon = (level, size, type) => {
  var index, icons
  if (!level || level < 1 || level > 5) {
    if (type === 'text') {
      return ''
    }
    return (<div></div>)
  }
  icons = []
  for (index = 0; index < level; index++) {
    if (type === 'text') {
      icons.push('★')
    }
    else {
      icons.push(<StarIcon key={index} style={{fontSize: size}}/>)
    }
  }
  return (
    <React.Fragment>
      {icons.map((icon) => icon)}
    </React.Fragment>
  )
}

export const getPuzzleTypeText = (value, language) => {
  var item
  item = constants.puzzleTypeItems.find((item) => item.value === value)
  if (!item) {
    return ''
  }
  return getWord(item.wid, language)
}

export const getTurnTypeText = (value, language, skin) => {
  var item
  if (skin === constants.SKIN.CARO) {
    item = constants.puzzleTurnItemsForCaro.find(item => item.value === value)  
  }
  else {
    item = constants.puzzleTurnItems.find(item => item.value === value)
  }
  if (!item) {
    return ''
  }
  return getWord(item.wid, language)
}

export const deleteUndefinedProps = (data) => {
  Object.keys(data).forEach(key => {
    if (data[key] === undefined) {
      delete data[key]
    }
  })
  return data
}

export const makeLiveGameResultStr = (gameResult) => {
  var winner, offerPlayer
  switch (gameResult.action) {
    case constants.ENDED_ACTION.FIVE:
      return (<Word wid={WID.MAKE_LIVE_GAME_RESULT_STR.MESSAGE_MAKE_A_FIVE_IN_A_ROW} insert={{ winner: gameResult.user.userName }}/>)
    case constants.ENDED_ACTION.RESIGN:
      winner = gameResult.user.userName === gameResult.player1.userName ? gameResult.player2 : gameResult.player1
      return (<Word wid={WID.MAKE_LIVE_GAME_RESULT_STR.MESSAGE_RESIGN} insert={{ winner: winner.userName, loser: gameResult.user.userName }}/>)
    case constants.ENDED_ACTION.OFFER_DRAW:
      offerPlayer = gameResult.user.userName === gameResult.player1.userName ? gameResult.player2 : gameResult.player1
      return (<Word wid={WID.MAKE_LIVE_GAME_RESULT_STR.MESSAGE_DRAW} insert={{ player: offerPlayer.userName }}/>)
    case constants.ENDED_ACTION.TIMEOUT:
      winner = gameResult.user.userName === gameResult.player1.userName ? gameResult.player2 : gameResult.player1
      return (<Word wid={WID.MAKE_LIVE_GAME_RESULT_STR.MESSAGE_TIME_OUT} insert={{ winner: winner.userName, loser: gameResult.user.userName }}/>)
    default:
      return ``
  }
}

export const deepCopy = (value) => {
  return deepExtend(undefined, value);
}

const deepExtend = (target, source) => {
  if (!(source instanceof Object)) {
      return source;
  }
  switch (source.constructor) {
      case Date:
          var dateValue = source;
          return new Date(dateValue.getTime());
      case Object:
          if (target === undefined) {
              target = {};
          }
          break;
      case Array:
          target = [];
          break;
      default:
          return source;
  }
  for (var prop in source) {
      if (!source.hasOwnProperty(prop)) {
          continue;
      }
      target[prop] = deepExtend(target[prop], source[prop]);
  }
  return target;
}

export const makePath = (url, language) => {
  var params, regstr, reObj
  params = url.split('/')
  if (params.length < 2) {
    return url
  }
  
  regstr = Object.keys(LANGUAGE_SHORT_CODE).map(key => '^' + LANGUAGE_SHORT_CODE[key] + '$').join('|')
  reObj = new RegExp(regstr, 'g')
  if (Boolean(params[1].match(reObj))) {
    params[1] = language
  }
  else {
    params.splice( 1, 0, language )
  }
  if (language === LANGUAGE_SHORT_CODE.JA) {
    params.splice(1, 1)
  }
  return params.join('/')
}

export const getLanguageShortCode = (url) => {
  var params, regstr, reObj
  params = url.split('/')
  if (params.length < 2) {
    return LANGUAGE_SHORT_CODE.JA
  }
  
  regstr = Object.keys(LANGUAGE_SHORT_CODE).map(key => '^' + LANGUAGE_SHORT_CODE[key] + '$').join('|')
  reObj = new RegExp(regstr, 'g')
  
  return Boolean(params[1].match(reObj)) ? params[1] : LANGUAGE_SHORT_CODE.JA
}

export const makeID = () => {
  var id = "", i, random;
  for (i = 0; i < 32; i++) {
    random = Math.random() * 16 | 0;

    if (i === 8 || i === 12 || i === 16 || i === 20) {
      id += "-"
    }
    id += (i === 12 ? 4 : (i === 16 ? ((random & 3) | 8) : random)).toString(16);
  }
  return id;
}

export const createURL = (card, language) => {
  var url, urlParam
  switch(card.type)  {
    case constants.boardType.WEB_BOARD:
      urlParam = createURLParamV2(card)
      url = `${getRootURL()}${makePath(`/board?${urlParam}`, language)}`
      break
    case constants.boardType.LIVE_GAME:
      url = `${getRootURL()}${makePath(`/live/${card.live.liveId}`, language)}`
      break
    case constants.boardType.GAME_ANALYZE:
      urlParam = createURLParamV2(card)
      url = `${getRootURL()}${makePath(`/live/${card.live.liveId}?${urlParam}`, language)}`
      break
    case constants.boardType.PUZZLE_VIEWER:
      if (card.moves[card.moves.length - 1].number > 0) {
        urlParam = createURLParamV2(card, ['mv', 'tr'])
        url = `${getRootURL()}${makePath(`/puzzle/${card.puzzleInfo.puzzleId}?${urlParam}`, language)}`
      }
      else {
        url = `${getRootURL()}${makePath(`/puzzle/${card.puzzleInfo.puzzleId}`, language)}`
      }
      break
    case constants.boardType.GAME_ROOM:
      urlParam = createURLParamV2(card)
      url = `${getRootURL()}${makePath(`/board?${urlParam}`, language)}`
      break
    default:
      url = ''
      break
  }
  return url
}


// WEBPACK FOOTER //
// ./src/lib/index.js